import { ArticleThumbnail } from './article-thumbnail'

export { ArticleThumbnail }
